import { useEffect, useState } from "react";

type LocalTimeProps = {
  /** Etykieta przed godziną - spójna z headerem "KRK · 2026" z grafik LinkedIn */
  label?: string;
  timeZone?: string;
  className?: string;
};

/**
 * Mały mono-zegar czasu lokalnego do stopki: "KRK · 14:32".
 * Detal w stylu topowych studiów, a tutaj z drugim dnem - grafiki LinkedIn
 * Wojtka mają header "KRK · 2026", więc strona i content mówią jednym językiem.
 *
 * Aktualizacja co 30 s (wystarczy dla minut, zero zbędnej pracy CPU).
 * Zero animacji - reduced-motion nie ma tu czego wyłączać.
 *
 * Użycie (stopka, obok copyright):
 *   <LocalTime />
 */
export function LocalTime({ label = "KRK", timeZone = "Europe/Warsaw", className }: LocalTimeProps) {
  const [time, setTime] = useState("");

  useEffect(() => {
    const format = () =>
      new Intl.DateTimeFormat("pl-PL", { hour: "2-digit", minute: "2-digit", timeZone }).format(new Date());
    setTime(format());
    const interval = setInterval(() => setTime(format()), 30_000);
    return () => clearInterval(interval);
  }, [timeZone]);

  return (
    <span
      className={className}
      style={{
        fontFamily: "'JetBrains Mono', monospace",
        fontSize: 12,
        letterSpacing: "0.08em",
        color: "rgba(255,255,255,0.45)",
        fontVariantNumeric: "tabular-nums",
      }}
    >
      {label} · {time}
    </span>
  );
}
